export const categories = [
  { slug: 'wanghong-heiliao', name: '网红黑料', icon: 'ri-user-search-line', description: '网红圈最新爆料，塌房现场直击' },
  { slug: 'mingxing-tafang', name: '明星塌房', icon: 'ri-alert-line', description: '明星塌房事件全记录' },
  { slug: 'chigua-riji', name: '吃瓜日记', icon: 'ri-file-list-3-line', description: '每日吃瓜资讯一网打尽' },
  { slug: 'redian-zhuizong', name: '热点追踪', icon: 'ri-fire-line', description: '全网热点事件实时追踪' },
  { slug: 'bagua-shendu', name: '八卦深度', icon: 'ri-search-eye-line', description: '深度扒皮，还原事件真相' },
  { slug: 'yule-quan', name: '娱乐圈', icon: 'ri-movie-2-line', description: '娱乐圈最新动态与内幕' },
];

export const trendingArticles = [
  {
    id: 1,
    slug: 'dingzhen-chuxian-zhibojian',
    title: '丁真现身某网红直播间，全程冷脸引网友热议',
    excerpt: '近日，丁真珍珠意外出现在某知名网红的直播间中，全程表情管理引发网友热议...',
    category: 'wanghong-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tibetan%20young%20man%20in%20traditional%20clothing%20standing%20in%20modern%20livestream%20studio%20with%20ring%20lights%20and%20cameras%2C%20serious%20expression%2C%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20warm%20amber%20tones%2C%20cinematic%20composition&width=800&height=600&seq=trending-01&orientation=landscape',
    heat: 98520,
    date: '2026-07-07',
    readTime: '5分钟',
    tags: ['丁真', '直播', '网红'],
  },
  {
    id: 2,
    slug: 'mou-dingliu-nanyixing-bengta',
    title: '某顶流男星被曝私下耍大牌，剧组工作人员集体爆料',
    excerpt: '多位剧组工作人员匿名爆料，称某当红男星在拍摄期间多次迟到、耍大牌...',
    category: 'mingxing-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20director%20chair%20and%20professional%20camera%20equipment%20under%20dramatic%20spotlight%2C%20dark%20atmosphere%2C%20film%20studio%20background%2C%20cinematic%20mood%2C%20warm%20spotlight%20beam%2C%20mysterious%20vibe%2C%20editorial%20photography&width=800&height=600&seq=trending-02&orientation=landscape',
    heat: 156320,
    date: '2026-07-06',
    readTime: '8分钟',
    tags: ['顶流', '耍大牌', '剧组'],
  },
  {
    id: 3,
    slug: 'wanghong-qinglv-fenshou',
    title: '知名网红情侣突然官宣分手，疑似第三者插足',
    excerpt: '粉丝超千万的网红情侣在社交平台同步发布分手声明，评论区瞬间炸锅...',
    category: 'wanghong-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20heart%20silhouette%20against%20split%20screen%20background%20with%20warm%20and%20cool%20color%20divide%2C%20emotional%20atmosphere%2C%20dramatic%20lighting%2C%20artistic%20composition%2C%20soft%20bokeh%20effect%2C%20modern%20minimalist%20aesthetic&width=800&height=600&seq=trending-03&orientation=landscape',
    heat: 203450,
    date: '2026-07-06',
    readTime: '6分钟',
    tags: ['网红情侣', '分手', '第三者'],
  },
  {
    id: 4,
    slug: 'dingji-nvxing-shuiwu',
    title: '顶流女星深夜发文道歉，税务问题再引关注',
    excerpt: '某位拥有数千万粉丝的女星深夜发布长文道歉声明，疑似涉及税务相关事宜...',
    category: 'mingxing-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20Chinese%20social%20media%20apology%20post%20on%20dark%20desk%20at%20night%2C%20warm%20screen%20glow%2C%20dim%20ambient%20light%2C%20dramatic%20mood%2C%20editorial%20style%2C%20cinematic%20depth%20of%20field&width=800&height=600&seq=trending-04&orientation=landscape',
    heat: 178900,
    date: '2026-07-05',
    readTime: '7分钟',
    tags: ['顶流女星', '税务', '道歉'],
  },
  {
    id: 5,
    slug: 'duan-shipin-wanghong-bei-ju',
    title: '短视频平台大网红被举报，账号或面临封禁',
    excerpt: '拥有5000万粉丝的短视频头部网红因涉嫌虚假宣传被大量用户举报...',
    category: 'wanghong-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20short%20video%20app%20interface%20with%20warning%20symbol%20overlay%2C%20dramatic%20red%20accent%20lighting%2C%20modern%20minimalist%20setting%2C%20digital%20tension%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=600&seq=trending-05&orientation=landscape',
    heat: 142800,
    date: '2026-07-05',
    readTime: '5分钟',
    tags: ['短视频', '举报', '封禁'],
  },
  {
    id: 6,
    slug: 'mou-nanyixing-yinsi-baoguang',
    title: '男星隐私遭恶意曝光，工作室发律师函维权',
    excerpt: '某知名男星个人隐私被恶意传播，工作室第一时间发布律师函...',
    category: 'yule-quan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Legal%20document%20with%20official%20seal%20on%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%2C%20formal%20atmosphere%2C%20warm%20amber%20tone%2C%20editorial%20style%2C%20professional%20legal%20photography&width=800&height=600&seq=trending-06&orientation=landscape',
    heat: 89500,
    date: '2026-07-04',
    readTime: '4分钟',
    tags: ['隐私', '律师函', '维权'],
  },
  {
    id: 7,
    slug: 'zongyi-jiemu-luping-baoliao',
    title: '综艺节目录制现场突发状况，导演组紧急叫停',
    excerpt: '某热门综艺节目录制过程中突发意外，现场观众拍到混乱画面...',
    category: 'redian-zhuizong',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20stage%20lights%20and%20empty%20audience%20seats%2C%20dramatic%20spotlight%20beams%2C%20chaotic%20atmosphere%2C%20production%20equipment%20scattered%2C%20warm%20theatrical%20lighting%2C%20editorial%20style&width=800&height=600&seq=trending-07&orientation=landscape',
    heat: 115600,
    date: '2026-07-04',
    readTime: '6分钟',
    tags: ['综艺', '录制', '意外'],
  },
  {
    id: 8,
    slug: 'xuanxiu-jiemu-neimu-jiepi',
    title: '选秀节目内幕大揭秘：投票造假产业链浮出水面',
    excerpt: '深度调查揭示选秀节目背后的投票造假灰色产业链，涉及金额惊人...',
    category: 'bagua-shendu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20area%20with%20mysterious%20silhouette%20behind%20curtain%2C%20dramatic%20shadow%20play%2C%20warm%20spotlight%20leaking%20through%20fabric%2C%20investigative%20journalism%20mood%2C%20cinematic%20composition%2C%20high%20contrast%20yellow%20light&width=800&height=600&seq=trending-08&orientation=landscape',
    heat: 167300,
    date: '2026-07-03',
    readTime: '10分钟',
    tags: ['选秀', '内幕', '投票造假'],
  },
];

export const reviewQuotes = [
  {
    id: 1,
    quote: '他们以为删除就能抹去一切，但互联网是有记忆的。每一个谎言最终都会被揭穿，每一个真相同样会浮出水面。',
    author: '匿名知情人',
    role: '前经纪公司员工',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20person%20in%20dark%20shadow%20against%20warm%20backlight%2C%20mysterious%20atmosphere%2C%20anonymous%20whistleblower%20vibe%2C%20dramatic%20lighting%2C%20minimalist%20portrait&width=120&height=120&seq=review-avatar-01&orientation=squarish',
    highlight: '互联网是有记忆的',
  },
  {
    id: 2,
    quote: '我在这个圈子里十几年了，见证过太多人设崩塌的瞬间。他们越是精心包装，崩塌的时候就越是惨烈。',
    author: '资深娱记老K',
    role: '娱乐记者 · 从业12年',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Mature%20journalist%20silhouette%20with%20press%20badge%2C%20dramatic%20backlight%20portrait%2C%20warm%20amber%20tones%2C%20professional%20atmosphere%2C%20minimalist%20style&width=120&height=120&seq=review-avatar-02&orientation=squarish',
    highlight: '人设崩塌的瞬间',
  },
  {
    id: 2,
    quote: '我在这个圈子里十几年了，见证过太多人设崩塌的瞬间。他们越是精心包装，崩塌的时候就越是惨烈。',
    author: '资深娱记老K',
    role: '娱乐记者 · 从业12年',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20person%20in%20dark%20shadow%20against%20warm%20backlight%2C%20mysterious%20atmosphere%2C%20anonymous%20whistleblower%20vibe%2C%20dramatic%20lighting%2C%20minimalist%20portrait&width=120&height=120&seq=review-avatar-01&orientation=squarish',
    highlight: '互联网是有记忆的',
  },
  {
    id: 3,
    quote: '粉丝们总说"相信哥哥"，但哥哥们连自己的真实面目都不敢让粉丝看到。这个圈子里，真实比黄金还珍贵。',
    author: '圈内从业者A',
    role: '知名经纪人',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20agent%20silhouette%20in%20suit%2C%20dramatic%20shadow%20portrait%2C%20corporate%20mystery%20vibe%2C%20warm%20background%20light%2C%20minimalist%20photography&width=120&height=120&seq=review-avatar-03&orientation=squarish',
    highlight: '真实比黄金还珍贵',
  },
];

export const dailyTracking = [
  { id: 1, title: '周一见：某85花疑与经纪人闹掰', date: '07-07', time: '10:30' },
  { id: 2, title: '片场路透：新剧男女主全程零交流', date: '07-07', time: '14:20' },
  { id: 3, title: '品牌方紧急撤下某代言人物料', date: '07-07', time: '16:45' },
  { id: 4, title: '知名导演朋友圈发文暗讽流量明星', date: '07-07', time: '20:10' },
  { id: 5, title: '某综艺选手录制中途被替换', date: '07-06', time: '09:15' },
];